import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service" updated="July 3, 2026" testid="terms-page">
      <p>
        Welcome to Learn Me. By creating an account or using our service, you agree to these Terms of
        Service. Please read them carefully. If you do not agree, please do not use Learn Me.
      </p>

      <LegalSection heading="1. Your account" testid="terms-account">
        <p>
          You are responsible for keeping your login credentials secure and for all activity that
          happens under your account. You must be at least 13 years old (or the age of digital consent
          in your country) to use Learn Me.
        </p>
      </LegalSection>

      <LegalSection heading="2. Ownership of generated content" testid="terms-ownership">
        <p>
          <strong>You own all content you generate on Learn Me.</strong> Any course, script, narration,
          or material produced from a topic you enter belongs to you. We claim no ownership over your
          generated courses and will not repurpose them as our own.
        </p>
        <p>
          You are free to use, share, and adapt the content you create, subject to applicable law and
          the rights of any third parties.
        </p>
      </LegalSection>

      <LegalSection heading="3. AI-generated content disclaimer" testid="terms-ai-disclaimer">
        <p>
          Learn Me uses artificial intelligence to generate educational content. This content is
          provided <strong>for educational and informational purposes only</strong> and may contain
          errors, omissions, or inaccuracies.
        </p>
        <p>
          You should independently verify any information before relying on it, and Learn Me is not a
          substitute for professional, legal, medical, financial, or other expert advice.
        </p>
      </LegalSection>

      <LegalSection heading="4. Payments and billing" testid="terms-payments">
        <p>
          <strong>Learn Me Coins</strong> are a prepaid, in-app credit used to generate courses. Coin
          purchases are <strong>final and non-refundable</strong>, except where required by law. Coins
          have no cash value and cannot be transferred or redeemed for money.
        </p>
        <p>
          The <strong>Scholar</strong> membership is a recurring subscription billed monthly. You may
          cancel at any time; your membership benefits continue until the end of the current billing
          period. Subscription fees already paid are non-refundable except where required by law.
        </p>
        <p>All payments are processed securely by Stripe. We do not store your full card details.</p>
      </LegalSection>

      <LegalSection heading="5. Acceptable use" testid="terms-acceptable-use">
        <p>
          You agree not to use Learn Me to generate unlawful, harmful, infringing, or abusive content,
          or to attempt to disrupt, reverse-engineer, or overload the service. We may suspend accounts
          that violate these terms.
        </p>
      </LegalSection>

      <LegalSection heading="6. Changes to these terms" testid="terms-changes">
        <p>
          We may update these Terms from time to time. If we make material changes, we will update the
          "Last updated" date above and, where appropriate, notify you in the app.
        </p>
      </LegalSection>

      <LegalSection heading="7. Contact" testid="terms-contact">
        <p>Questions about these Terms? Reach us through the in-app Support page.</p>
      </LegalSection>
    </LegalLayout>
  );
}
